import { getDayNameAndDate } from 'helpers/dates'
import { useAppSelector } from 'store/hooks'
import { useAutoScroll } from 'utils/hooks'
import { useEffect, useState } from 'react'
import OrderedTicket, {
    OrderedTicketItem,
} from 'components/shared/OrderedTicket'
import { DEFAULT_QUANTITY } from 'store/cabana-slice'
import { useCabana } from 'store/cabana-slice/hooks'
import { DefaultTheme } from 'styled-components'

interface OrderedCabanaProps {
    id: string
    cabanaIndex: number
    unitPrice: number
    cabanasQuantity: number
    editHandler: (cabanaIndex: number) => void
    theme?: DefaultTheme
}

const OrderedCabana = ({
    id,
    cabanaIndex,
    unitPrice,
    cabanasQuantity,
    editHandler,
    theme,
}: OrderedCabanaProps) => {
    const { animatePendingScroll, calculateScroll, scrollIndex } =
        useAutoScroll()
    const { removeCabanaFromCart } = useCabana(cabanaIndex)
    const { cabanas } = useAppSelector((state) => state.cabana)
    const { cabana } = cabanas[cabanaIndex]
    const [isDeleteError, setIsDeleteError] = useState(false)

    useEffect(() => {
        animatePendingScroll(`cabana-${cabanaIndex}`)
    }, [scrollIndex])

    const handleDeleteCabana = () => {
        setIsDeleteError(false)
        removeCabanaFromCart().then(({ isSuccess }) => {
            isSuccess
                ? calculateScroll({
                      trigerringSection: 'cabanas',
                      trigerringAction: 'delete',
                  })
                : setIsDeleteError(true)
        })
    }

    const handleEditCabana = () => {
        editHandler(cabanaIndex)
        calculateScroll({
            trigerringSection: 'cabanas',
            trigerringAction: 'edit',
            index: cabanaIndex,
        })
    }

    const cabanaItem: OrderedTicketItem = (() => {
        const {
            quantity,
            detail: { date },
        } = cabana

        return {
            quantity: quantity || DEFAULT_QUANTITY,
            text: 'Cabana',
            date: getDayNameAndDate({ date }),
        }
    })()

    return (
        <OrderedTicket
            id={id}
            items={[cabanaItem]}
            price={unitPrice * cabanasQuantity}
            onDelete={handleDeleteCabana}
            onEdit={handleEditCabana}
            isActionError={isDeleteError}
            theme={theme}
            shouldKeepBorderInDarkMode={true}
            testIdPrefix={id}
        />
    )
}

export default OrderedCabana
